module.exports = __webpack_public_path__ + "_assets/img/pApple.fe4f01ad.svg";